import { Injectable } from '@angular/core';

import { InitConstant, UrlConstant, DialogConstant } from '../Constant';

import { AuthService } from './auth.service';
import { DialogService } from './dialog.service';
import { ToastService } from './toast.service';
import { ApiService } from './api.service';
import { LogService } from './log.service';
import { EventService } from './event.service';

@Injectable({
    providedIn: 'root'
})
export class UploadService
{
    private progress_list: any[] = [];
    private upload_timer: any = null;

    constructor(
        private auth: AuthService,
        private dialog: DialogService,
        private toast: ToastService,
        private api: ApiService,
        private log: LogService,
        private event: EventService
    )
    {
    }

    async start(file, file_name, parent_id, duplicate, recover_type, rand_name)
    {
        const idx = this.getIndex(rand_name);

        if (idx < 0) {
            return { status: 3, file_name: file_name, rand_name: rand_name };
        }

        this.progress_list[idx].is_start = true;

        let upload_result = 0;
        let is_break = false;

        if (this.isStop(rand_name) === true) {
            this.setStop(rand_name);
            return { status: 3, file_name: file_name, rand_name: rand_name };
        }

        try {
            let now_mtime = Math.floor(Date.now() / 1000);
            let offset = 0;
            const file_mime_type = file.type;
            const file_size = file.size;
            const file_mtime = Math.floor(file.lastModified / 1000);

            if (recover_type == 1) {
                file_name = await this.fileRename(file_name, parent_id);
            } else if (recover_type == 2) {
                if (await this.api.cancel({
                    file_flg: 1,
                    parent_id: (this.auth.empty(parent_id) ? "" : parent_id),
                    file_name: file_name,
                    now_mtime: now_mtime
                }) === false) {
                    upload_result = 9;
                    const err_msg = this.api.getErrorMessage(`cancel:${now_mtime}`);
                    throw err_msg;
                }
            }

            let upload_total = file_size / InitConstant.UPLOAD_SPLIT_SIZE;
            upload_total = (upload_total > Math.floor(upload_total) ? Math.floor(upload_total) + 1 : (upload_total == 0 ? 1 : upload_total));

            for (let i = 0; i < upload_total; i++) {
                now_mtime = Math.floor(Date.now() / 1000);

                if (this.isStop(rand_name) === true) {
                    if (i > 0) {
                        await this.api.cancel({
                            file_flg: 1,
                            parent_id: (this.auth.empty(parent_id) ? "" : parent_id),
                            file_name: file_name,
                            now_mtime: now_mtime
                        });
                    }
                    is_break = true;
                    upload_result = 3;
                    break;
                }

                const slice = file.slice(offset, offset + InitConstant.UPLOAD_SPLIT_SIZE, file_mime_type);
                const upload_count = i + 1;

                const params = {
                    now_mtime: now_mtime,
                    file_flg: 1,
                    parent_id: (this.auth.empty(parent_id) ? "" : parent_id),
                    file_name: file_name,
                    file_size: file_size,
                    file_mtime: file_mtime,
                    file_mime_type: file_mime_type,
                    total_count: upload_total,
                    upload_count: upload_count,
                    duplicate: duplicate,
                    data: slice
                };

                const resp_data = await this.api.fileupload(params);

                if (this.auth.empty(resp_data)) {
                    upload_result = 9;
                    const err_msg = this.api.getErrorMessage(`fileupload:${now_mtime}`);
                    throw err_msg;
                }

                if (resp_data['status'] == 0) {
                    if (resp_data['retry'] != 0) {
                        upload_result = resp_data['retry'];
                    } else {
                        upload_result = 9;
                    }
                    const err_msg = this.api.getErrorMessage(`fileupload:${now_mtime}`);
                    throw err_msg;
                }

                offset += InitConstant.UPLOAD_SPLIT_SIZE;
                this.setSize(file_size, slice.size, rand_name, false);
            }

        } catch (err) {
            this.log.error(`upload -> ${err}: ${file_name}`);

            if (upload_result == 9) {
                let dialog_msg = (this.auth.empty(err) ? DialogConstant.UPLOAD_FILE_ERR : err);
                if (dialog_msg == 'file.create.parent_id.notfound') {
                    dialog_msg = DialogConstant.UPLOAD_PARENT_ID_ERR;
                }

                this.toast.errorNotification(dialog_msg+`(${file_name})`);
            }
        }

        this.setStop(rand_name);

        let cnt = await this.getUploadCount();
        if (is_break === false) await this.dialog.progressClose(rand_name, cnt);

        return { status: upload_result, file_name: file_name, rand_name: rand_name };
    }

    async setProgress(row, parent_id, rand_name)
    {
        const file_name = this.auth.replaceCharactor(row.name);

        this.progress_list.push({
            rand_name: rand_name,
            total_size: row.size,
            comp_size: 0,
            is_start: false,
            file: row,
            file_name: file_name,
            parent_id: parent_id
        });

        this.setSize(row.size, 0, rand_name, true);

        const func = async() => {
            this.setStop(rand_name);
            let stop_cnt = await this.getUploadCount();
            this.dialog.progressClose(rand_name, stop_cnt);
        };

        let cnt = await this.getUploadCount();

        this.event.show_progress_badge_subject.next(cnt);

        await this.dialog.progress(func, file_name, rand_name);

        this.startUploads();
    }

    startUploads()
    {
        clearInterval(this.upload_timer);

        this.upload_timer = setInterval(async() => {
            if (await this.getUploadCount() == 0) {
                clearInterval(this.upload_timer);
            } else if (this.progress_list.findIndex((v: any) => v.is_start === true) < 0) {
                let row = this.progress_list[0];
                let ret = await this.start(row.file, row.file_name, row.parent_id, 0, 0, row.rand_name);

                if (ret.status == 1 || ret.status == 2) {
                    await this.uploadConfirm(row.file, ret.file_name, row.parent_id, ret.status, ret.rand_name);
                } else if (ret.status == 0) {
                    await this.uploadResult(row.parent_id);
                }
            }
        }, 1000);
    }

    async uploadConfirm(file, file_name, parent_id, status, rand_name)
    {
        const btn9 = {
            text: DialogConstant.BUTTON_CANCEL,
            role: 'cancel'
        };

        if (status == 1) {
            const btn1 = {
                text: DialogConstant.UPLOAD_CONFIRM_BUTTON_OK,
                handler: async() => {
                    await this.setProgress(file, parent_id, rand_name);
                    let ret = await this.start(file, file_name, parent_id, 1, 0, rand_name);

                    if (ret.status == 1 || ret.status == 2) {
                        await this.uploadConfirm(file, ret.file_name, parent_id, ret.status, rand_name);
                        return;
                    }

                    await this.uploadResult(parent_id);
                }
            };
            const btn2 = {
                text: DialogConstant.UPLOAD_CONFIRM_BUTTON_RENAME,
                handler: async() => {
                    await this.setProgress(file, parent_id, rand_name);
                    let ret = await this.start(file, file_name, parent_id, 0, 1, rand_name);

                    if (ret.status == 1 || ret.status == 2) {
                        await this.uploadConfirm(file, ret.file_name, parent_id, ret.status, rand_name);
                        return;
                    }

                    await this.uploadResult(parent_id);
                }
            };

            const msg = DialogConstant.UPLOAD_CONFIRM_OVERWRITE.replace('{FILE_NAME}', file_name);

            this.dialog.confirm(DialogConstant.CONFIRM_TITLE, msg, [btn1, btn2, btn9]);
        } else if (status == 2) {
            const btn1 = {
                text: DialogConstant.UPLOAD_CONFIRM_BUTTON_OK,
                handler: async() => {
                    await this.setProgress(file, parent_id, rand_name);
                    let ret = await this.start(file, file_name, parent_id, 0, 2, rand_name);

                    if (ret.status == 1 || ret.status == 2) {
                        await this.uploadConfirm(file, ret.file_name, parent_id, ret.status, rand_name);
                        return;
                    }

                    await this.uploadResult(parent_id);
                }
            };

            const btn2 = {
                text: DialogConstant.UPLOAD_CONFIRM_BUTTON_RENAME,
                handler: async() => {
                    await this.setProgress(file, parent_id, rand_name);
                    let ret = await this.start(file, file_name, parent_id, 0, 1, rand_name);

                    if (ret.status == 1 || ret.status == 2) {
                        await this.uploadConfirm(file, ret.file_name, parent_id, ret.status, rand_name);
                        return;
                    }

                    await this.uploadResult(parent_id);
                }
            };

            const msg = DialogConstant.UPLOAD_CONFIRM_REUPLOAD.replace('{FILE_NAME}', file_name);
            this.dialog.confirm(DialogConstant.CONFIRM_TITLE, msg, [btn1, btn2, btn9]);
        }
    }

    uploadResult(parent_id)
    {
        this.event.page_reload_subject.next(parent_id);
    }

    getIndex(key)
    {
        return this.progress_list.findIndex((v: any) => v.rand_name == key);
    }

    async getUploadCount()
    {
        let cnt = this.progress_list.length;

        this.log.debug(`getUploadCount -> ${cnt}`);

        return cnt;
    }

    async getUploadSize()
    {
        let total_size = 0;
        for (let file of this.progress_list) {
            total_size += file.total_size;
        }

        this.log.debug(`getUploadSize -> ${total_size}`);

        return total_size;
    }

    setSize(total_size, comp_size, key, reset)
    {
        if (this.isStop(key) === true) return;

        const idx = this.getIndex(key);

        if (idx < 0) return;

        if (reset === true) {
            this.progress_list[idx].total_size = total_size;
            this.progress_list[idx].comp_size = 0;
        } else {
            this.progress_list[idx].total_size = total_size;
            this.progress_list[idx].comp_size += comp_size;

            let remaining_size = this.progress_list[idx].total_size - this.progress_list[idx].comp_size;
            remaining_size = (remaining_size <= 0 ? 0 : remaining_size);
            const comp_percent = (remaining_size > 0 ? Math.floor((this.progress_list[idx].comp_size / this.progress_list[idx].total_size) * 100) : 0);
            const comp_barsize = 100 - comp_percent;

            this.dialog.setProgressPercent(comp_barsize, key);
        }
    }

    setStop(key)
    {
        const idx = this.getIndex(key);

        if (idx >= 0) {
            this.progress_list.splice(idx, 1);
        }
    }

    isStop(key)
    {
        const idx = this.getIndex(key);
        return idx < 0;
    }

    async fileRename(file_name, parent_id)
    {
        let new_file_name = file_name;
        let file_parts = file_name.split('.');
        const ext = file_parts.pop();
        let num = 1;
        while (true) {
            let now_mtime = Date.now();
            new_file_name = await this.replaceFileNameByName(new_file_name, num);

            const ret = await this.api.getfile(new_file_name, (this.auth.empty(parent_id) ? "" : parent_id), now_mtime, false, 0);

            if (!this.api.isSuccess(`getfile:${now_mtime}`)) {
                break;
            }

            await new Promise(resolve => setTimeout(resolve, 500));
            num++;
        }

        return new_file_name;
    }

    replaceFileNameByName(name, num)
    {
        let file_name = name;
        let file_parts = file_name.split('.');
        const ext = file_parts.pop();
        file_name = (file_parts.length > 1 ? file_parts.join('.') : file_parts[0]);
        file_name = file_name.replace(/\([0-9]+\)$/, "");
        file_name += `(${num})`+'.'+ext;

        return file_name;
    }
}
